
<template>
  <!--单元管理-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="unit_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="true"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
    </x-tabula>
  </div>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'unit',
  data () {
    return {
      cascadeParam: {},
      searchList: [
        { label: '', props: ['community_id'], placeholder: '小区', options: [], inputType: 'select', handle: ($event) => this.communityChange(5, $event) },
        { label: '', props: ['keywords'], placeholder: '名称、编码', options: [], inputType: 'input' },
        { label: '', props: ['create_date'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' },
        { label: '', props: ['areas'], placeholder: '省市', options: [], inputType: 'cascader', changeOnSelect: true },
        { label: '', props: ['property_id'], placeholder: '物业公司', options: [], inputType: 'select' },
        { label: '', props: ['building_id'], placeholder: '楼栋', options: [], inputType: 'select' }
      ],
      searchParams: {
        community_id: '',
        keywords: '',
        create_date: '',
        areas: '',
        property_id: '',
        building_id: ''
      },
      tableOptList: [
        { text: '新增', icon: 'plus', key: 'addbtn' },
        { text: '删除', icon: 'close', disabled: true, key: 'batchDel' }
      ],
      rowOptList: [
        { text: '修改', handle: (record) => this.$children[0].toEdit(record), key: 'edit' },
        { text: '删除', handle: (record) => this.$children[0].showDeleteConfirm(record), key: 'delete' }
      ],
      columns: [
        { title: 'ID', dataIndex: 'unit_id', align: 'left', width: '' },
        { title: '所在城市', dataIndex: 'area', align: 'left', width: '' },
        { title: '所属楼栋', dataIndex: 'building', align: 'left', width: '' },
        { title: '名称', dataIndex: 'unit_name', align: 'left', width: '' },
        { title: '编号', dataIndex: 'unit_no', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: '/units',
        resHandle: this.resHandle, // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addUnit',
        title: '修改单元'
      },
      deleteParam: {
        url: '/units',
        param: {pk_key: 'unit_id', pk_val: ''},
        title: '单元',
        key: 'unit_name'
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this.regionSelect(3);
      this.propertySelect(4);
      this.communitySelect(0, 'searchList', 1);
    },
    resHandle (res) {
      res.forEach((el) => {
        el.building = `${el.community_name} ${el.building_name}`;
      });
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/baseData/unit/unit.vue